import React, { useState } from "react";
import { Box, Typography, TextField, Alert, Grid, Paper } from "@mui/material";
import { ContainedButton } from "../buttonCompo/Buttons";

const SupportForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!formData.message.trim()) newErrors.message = "Message cannot be empty";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setTimeout(() => {
      setSuccessMessage("Your support request has been submitted successfully!");
      setFormData({ name: "", email: "", message: "" });
      setErrors({});
    }, 1000);
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundImage: `url(${process.env.PUBLIC_URL}/icons/login/loginBg.svg)`,
      backgroundSize: "cover",
      backgroundPosition: "center", // Center the image
    }}>
      <Grid container spacing={4} maxWidth={1200} sx={{ borderRadius: "10px", padding: "20px" }}>
        <Grid item xs={12}>
          <Box sx={{ padding: "20px", borderRadius: "10px" }}>
            <Typography variant="h4" fontWeight={700} color="#1560BD" sx={{ textAlign: "center" }} gutterBottom>
              PillDrop Support
            </Typography>

            <Typography variant="h6" fontWeight={700} gutterBottom>
              How Pharmacies Can Register
            </Typography>
            <Typography variant="body1" paragraph>
              Thank you for your interest in joining PillDrop, the convenient medicine delivery service trusted by pharmacies nationwide. Follow these simple steps to register and start delivering medications effortlessly:
            </Typography>
            <Typography variant="subtitle1" fontWeight={600}>Step 1: Visit Our Office</Typography>
            <ul style={{ marginLeft: "20px" }}>
              <li>Pharmacies interested in partnering with PillDrop must first visit our local PillDrop office.</li>
              <li>Our office location and visiting hours are available on our contact page.</li>
            </ul>
            <Typography variant="subtitle1" fontWeight={600}>Step 2: Complete Contract Agreement</Typography>
            <ul style={{ marginLeft: "20px" }}>
              <li>Our representatives will guide you through the registration process and contractual terms.</li>
            </ul>
            <Typography variant="subtitle1" fontWeight={600}>Step 3: Verification and Confirmation</Typography>
            <ul style={{ marginLeft: "20px" }}>
              <li>After submitting required documentation, our team will review and confirm your registration.</li>
            </ul>

            <Typography variant="h6" fontWeight={700} gutterBottom>
              PillDrop Delivery Services for Pharmacies
            </Typography>
            <ul style={{ marginLeft: "20px" }}>
              <li>Quick Order Management: Easily create and track medicine deliveries.</li>
              <li>Secure and Reliable Deliveries: Safe and timely handling of medications.</li>
              <li>Real-Time Updates: Stay informed with our tracking system.</li>
            </ul>

            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ mt: 2 }}>
              Customer and Technical Support
            </Typography>
            <ul style={{ marginLeft: "20px" }}>
              <li>Support Hotline: Available weekdays from 8 AM to 8 PM.</li>
              <li>Email Support: Reach us at support@pilldrop.com.</li>
              <li>FAQs: Visit our FAQ section for quick answers.</li>
            </ul>
            <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mt: 2 }}>
              Join PillDrop today and revolutionize your pharmacy's delivery capabilities!
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SupportForm;
